import { Button, TextField } from "@material-ui/core";

import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Fade,
  Link,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { MovieColabLogo } from "../../Components/Utilities/MovieColabLogo";
import signupAndLoginStyles from "./signupAndLoginStyle";

const ForgotPasswordPage = () => {
  const classes = signupAndLoginStyles();

  const [formData, setFormData] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email is invalid";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });

    if (errors[field]) {
      setErrors({ ...errors, [field]: "" });
    }

    if (loginError) setLoginError("");
    if (successMessage) setSuccessMessage("");
  };

  const handleSignup = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    setLoginError("");
    setSuccessMessage("");

    try {
      const payload = {
        email: formData.email,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}reset-password/`,
        payload,
      );

      setSuccessMessage(
        "Reset code sent to you email successfully. Please check your email for the next step",
      );

      setFormData({ email: "" });
      setErrors({});
      console.log("Signup success:", res.data);
    } catch (error) {
      console.log(error);

      const apiMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        "Signup failed. Please try again.";
      setLoginError(apiMessage);
      console.error("Signup error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className={classes.loginContainer}>
      {/* Purple Glow */}
      <div className={classes.glow} />

      <Box sx={{ width: "500px", zIndex: 2 }}>
        {/* Logo */}
        <Box className={classes.topLogo}>
          <MovieColabLogo />
          <Typography className={classes.brand}>Movie Colab</Typography>
        </Box>

        {/* Card */}
        <Card className={classes.loginCard}>
          <CardContent className={classes.cardContent}>
            <Box className={classes.headerContainer}>
              <Typography className={classes.welcomeTitle}>
                Reset Password
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#7A7A83",
                  fontSize: "14px",
                  mt: 1,
                }}
              >
                Type your email and we'll send you a link to reset your password
              </Typography>
            </Box>

            {loginError && (
              <Fade in>
                <Alert
                  severity="error"
                  className={classes.errorAlert}
                  onClose={() => setLoginError("")}
                >
                  {loginError}
                </Alert>
              </Fade>
            )}

            <Box
              component="form"
              onSubmit={handleSignup}
              className={classes.loginForm}
              noValidate
            >
              {/* Email */}
              <div>
                <div
                  className={classes.inputLabel}
                  style={{ marginBottom: "8px" }}
                >
                  Email
                </div>
                <div className={classes.inputWrapper}>
                  <TextField
                    type="email"
                    fullWidth
                    value={formData.email}
                    onChange={handleInputChange("email")}
                    error={!!errors.email}
                    helperText={errors.email}
                    InputProps={{
                      disableUnderline: true,
                      style: { fontFamily: "Poppins", marginTop: "5px" },
                    }}
                    className={classes.input}
                    placeholder="Enter email"
                  />
                </div>
              </div>

              {/* Button */}
              <Button
                type="submit"
                disabled={isLoading || formData.email?.length === 0}
                fullWidth
                className={classes.primaryButton}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Send Reset Email"
                )}
              </Button>
            </Box>

            {/* Bottom */}
            <Divider className={classes.divider} />

            <Box
              className={classes.linksContainer}
              sx={{
                justifyContent: "center",
              }}
            >
              {/* <Link href="#" className={classes.smallLink}>
                Forgot Password?
              </Link> */}
              <Link href="/login" className={classes.smallLink}>
                Back to Login
              </Link>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default ForgotPasswordPage;
